/* eslint-disable no-eval */
/* eslint-disable eqeqeq */
import React from 'react';
import { Button, Upload, Space } from 'antd';
import * as XLSX from "xlsx";
import { ReplicarUnidadMedida } from '../../../atc/servicios-oma/cadenas-custodia/modals/ReplicarUnidadMedida';
import { BasePage } from '../../../../framework/pages/BasePage';
import BarButtonFw, { BUTTON_DEFAULT } from '../../../../framework/bar-button/BarButtonFw';
import { ICON } from '../../../../constants/iconConstants';
import GridFw from '../../../../framework/grid/GridFw';
import { DATE_FORMAT, PAGE_MODE } from "../../../../constants/constants";

export class SubparametrosResultadosAireModal extends BasePage {
  createPageProperties = (pageApi) => {
    return {
      title: 'Ingreso de Resultados',
    };
  }

  renderPage(pageApi) {
    const getGridParametros = () => pageApi.getComponent('parametrosGrid');

    const barHeaderConfig = {
      fields: [
        { ...BUTTON_DEFAULT.SAVE, onClick: () => getGridParametros().save() },
        { ...BUTTON_DEFAULT.RETURN, onClick: () => pageApi.name.hideModal() },
        { ...BUTTON_DEFAULT.EXECUTE, onClick: ( ) => { 
            let listresult = getGridParametros().state.dataList;      
            if (listresult){    
              listresult.forEach(item => {          
                if(item.resultado == "N"){         
                  item.resultado = 0;            
                }  
                else if(item.resultado == "NNE"){    
                  item.resultado = 22.5;
                } 
                else if(item.resultado == "NE"){    
                  item.resultado = 45;
                }  
                else if(item.resultado == "ENE"){    
                  item.resultado = 67.5;
                }  
                else if(item.resultado == "E"){    
                  item.resultado = 90;
                }  
                else if(item.resultado == "ESE"){    
                  item.resultado = 112.5;
                }  
                else if(item.resultado == "SE"){    
                  item.resultado = 135;
                }  
                else if(item.resultado == "SSE"){    
                  item.resultado = 157.5;
                }  
                else if(item.resultado == "S"){    
                  item.resultado = 180;
                }  
                else if(item.resultado == "SSW"){    
                  item.resultado = 202.5;
                }  
                 else if(item.resultado == "SW"){    
                  item.resultado = 225;
                }
                 else if(item.resultado == "WSW"){    
                  item.resultado = 247.5;
                }
                 else if(item.resultado == "W"){    
                  item.resultado = 270;
                }
                 else if(item.resultado == "WNW"){    
                  item.resultado = 292.5;
                }
                 else if(item.resultado == "NW"){    
                  item.resultado = 315;
                }
                 else if(item.resultado == "NNW"){    
                  item.resultado = 337.5;
                } 
              });      
               getGridParametros().refresh();      
            } 
          } 
        }
      ]
    };

    const ConfiguracionModalConfig = (data) => {
      let obj = {};
      obj = { ...obj, data };
      return {
        width: 800,
        maskClosable: false,
        component: <ReplicarUnidadMedida name={obj} getParentApi={pageApi.getApi} />,
      };
    };

    const esValidoNumero = (value) => {
      const parsedValue = value;
      return !isNaN(parsedValue) && parsedValue.toString() === value.toString();
    }

    const obtenerCondicion = (data, value) => {
      const val = parseFloat(value);
      // eslint-disable-next-line array-callback-return
      return data.findIndex(el => {
        if (el.IdTipo_Condicion == 1 && el.Valor_1 >= val) return el
        else if (el.IdTipo_Condicion == 2 && el.Valor_1 <= val && el.Valor_2 >= val) return el
        else if (el.IdTipo_Condicion == 3 && el.Valor_1 <= val) return el
      })
    }

    const propsFile = {
      name: 'file',
      accept: ".xlsx, .xlx",
      showUploadList: false,
      beforeUpload: async (file) => {
        await getGridParametros().saveItemEditing();
        await getGridParametros().refresh();
        var reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = e => {
          const bufferArray = e.target.result;
          const workbook = XLSX.read(bufferArray, { type: "binary", cellText: false, cellDates: true });
          const { SheetNames, Sheets } = workbook;
          const sheetName = SheetNames[0];
          const woorSheet = Sheets[sheetName];
          const data_file = XLSX.utils.sheet_to_json(woorSheet, { header: 1, defval: '', raw: false, dateNF: 'yyyy-mm-dd' });

          getGridParametros().getData().forEach((x, index) => {
            console.log(x);
            if (data_file[index] != undefined) {
              const resultado = (data_file[index][0] == undefined || data_file[index][0] == "" ? "" :
                data_file[index][0].includes("<") == true ? "<" + parseFloat(data_file[index][0].replace("<", "")).toFixed(x.cantidad_decimales) :
                  data_file[index][0].includes(">") == true ? ">" + parseFloat(data_file[index][0].replace(">", "")).toFixed(x.cantidad_decimales) :
                    parseFloat(data_file[index][0]).toFixed(x.cantidad_decimales));

              const condiciones = JSON.parse(x.condicion_criterio);
              const indexFind = obtenerCondicion(JSON.parse(x.condicion_criterio), resultado);
              const valIncert = data_file[index][0].toLowerCase() == 'nd'
                ? 'N.A.'
                : esValidoNumero(parseFloat(resultado)) 
                  ? condiciones[indexFind]?.IdTipoVariable == 2
                    ? eval(condiciones[indexFind]?.Resultado.replace("Resultado", resultado))
                    : condiciones[indexFind]?.Resultado
                  : '';
   
              getGridParametros().updateItem({
                ...x,
                // incertidumbre: valIncert,
                incertidumbre: data_file[index][1],
                resultado: esValidoNumero(parseFloat(resultado)) ? resultado : data_file[index][0],
                fecha_ini: data_file[index][2],
                hora_ini: data_file[index][3]
              });
            }
          });
          getGridParametros().refresh();
          // getGridParametros().setData(replicar);
        };
        return false;
      },
    };

    const gridConfig = {
      rowId: 'id_cadena_subparametro',
      showIndex: true,
      autoLoad: true,
      pagination: {
        server: false,
        showSizeChanger: true,
      },
      load: {
        queryId: 945,
        params: () => {
          return {
            id_parametro: pageApi?.name?.data.ID_PARAMETRO
          }
        }
      },
      save: {
        queryId: 927,
      },
      fields: [
        { name: 'sub_parametro', label: 'Sub Parámetro' },
        {
          type: 'select', name: 'um_id', label: 'Unidad Medida', labelName: 'desUM', column: 4, search: true, editable: true, load: {
            queryId: 583, params: () => {
              return {
                id_metodo: getGridParametros().itemEditing.id_metodo,
              }
            }
          }
        },
        {
          type: 'text',
          name: 'resultado',
          label: 'Resultado',
          editable: true,
          onChange: (value, values, formApi) => {
            const itemEdit = getGridParametros().itemEditing;
            const condiciones = JSON.parse(itemEdit.condicion_criterio);

            const indexFind = esValidoNumero(value) ? obtenerCondicion(condiciones, value) : { Resultado: '' }
            const resultado = condiciones[indexFind]?.IdTipoVariable == 2
              ? eval(condiciones[indexFind]?.Resultado.replace("Resultado", value))
              : condiciones[indexFind]?.Resultado;

            formApi?.setFieldData("incertidumbre", resultado || '');
            getGridParametros().refresh();
          }
        },
        {
          name: 'incertidumbre',
          label: 'Incertidumbre',
          editable: true,
        },
        {
           type: "date",
           name: "fecha_ini",
           label: "Fecha Muestreo",   
           editable:true,
           format: "DD/MM/YYYY",
           inputFormat: DATE_FORMAT.YYYYMMDD,
         },
         {
           type: "date",
           name: "hora_ini",
           label: "Hora Muestreo",
           // onClick: (value, row) => {  
           //   if(row?.Esbloqueo_supervisor_OMA === 1){
           //     getGrid().getConfig().fields[4].editable = false;  
           //   }
           //   else{
           //     getGrid().getConfig().fields[4].editable = true; 
           //   }
           // }, 
           editable:true,
           format: DATE_FORMAT.HHmm,
           inputFormat: DATE_FORMAT.HHmm,
         },        
        {
          label:
            <Space size="middle">
              <Upload {...propsFile}><Button type="text" shape="circle" icon={ICON.EXCEL} style={{ color: "green" }} /></Upload>
              <Button type="text" shape="circle" icon={ICON.COPY} style={{ color: "green" }} onClick={() => pageApi.showModal(ConfiguracionModalConfig({
                id_metodo: pageApi?.name?.data.id_metodo
              }))} />
            </Space>
          , color: "green", with: 5
        },
      ]
    };

    return (
      <>
        <GridFw
          name="parametrosGrid"
          getParentApi={pageApi.getApi}
          config={gridConfig}
        />
        <BarButtonFw
          name="agregarButton"
          getParentApi={pageApi.getApi}
          config={barHeaderConfig}
        />
      </>
    )
  }
}